export default {
      id: "tale-icon-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "ico/gefera/sprite.svg#tale-icon",
      toString: function () {
        return this.url;
      }
    }